import applianceImg from "assets/applicationImages/appliance.png";
import constructionImg from "assets/applicationImages/construction.png";
import consumerProductsImg from "assets/applicationImages/consumer-products.png";
import electricalImg from "assets/applicationImages/electrical.png";
import electronicsImg from "assets/applicationImages/electronics.png";
import healthcareImg from "assets/applicationImages/healthcare.png";
import industryImg from "assets/applicationImages/industry.png";
import mobilityImg from "assets/applicationImages/mobility.png";

interface ApplicationUiConfig {
  image: string;
  accentColor: string;
}

export const APPLICATION_UI_CONFIG: Record<string, ApplicationUiConfig> = {
  Internal: { image: industryImg, accentColor: "#009fe4" },
  Healthcare: { image: healthcareImg, accentColor: "#009fe4" },
  Mobility: { image: mobilityImg, accentColor: "#ff7f41" },
  Electronics: { image: electronicsImg, accentColor: "#e5007e" },
  Electrical: { image: electricalImg, accentColor: "#00bb7e" },
  Appliance: { image: applianceImg, accentColor: "#009fe4" },
  "Consumer Products": { image: consumerProductsImg, accentColor: "#7d55c7" },
  Construction: { image: constructionImg, accentColor: "#00bb7e" },
};
